import { useAppQuery } from './useAppQuery';

export interface CourseSearchResult {
  id: string;
  title: string;
  description: string | null;
  imageUrl: string | null;
  level: string | null;
  courseType: string | null;
  format: string | null;
  averageRating: number | null;
  numberOfReviews: number;
  score: number;
}

export interface CourseSearchResponse {
  results: CourseSearchResult[];
}

export const useSearchCourses = (query: string) => {
  return useAppQuery<CourseSearchResponse>('/Course/search', {
    config: { params: { query } },
    enabled: !!query.trim(),
    placeholderData: undefined,
  });
};
